<template>
    <div class="class-1">
      <!-- Header -->
      <AppHeader />
  
      <!-- Edit Tax Form -->
      <div class="container mt-4">
        <div class="row">
          <div class="col-12">
            <h2>Edit Tax</h2>
            <form @submit.prevent="handleSubmit">
              <div class="form-row">
  <div class="form-group col-md-12">
    <label for="name">Tax Name</label>
    <input 
      type="text" 
      class="form-control" 
      id="name" 
      v-model="form.name" 
      placeholder="e.g., VAT, GST, Sales Tax" 
      required
    >
  </div>
</div>
              <!-- Percentage Input -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="percentage">Tax Percentage (%)</label>
                  <input 
                    type="number" 
                    class="form-control" 
                    id="percentage" 
                    v-model="form.percentage" 
                    placeholder="e.g., 15" 
                    min="0"
                    max="100"
                    step="0.01"
                    required
                  >
                </div>
              </div>
  
              <!-- Net Total Toggle -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <div class="form-check">
                    <input 
                      type="checkbox" 
                      class="form-check-input" 
                      id="nettotal" 
                      v-model="form.nettotal"
                    >
                    <label class="form-check-label" for="nettotal">
                      Apply to Net Total?
                    </label>
                    <small class="text-muted d-block">
                      If enabled, tax will be calculated on the net total.
                    </small>
                  </div>
                </div>
              </div>
  
              <!-- Buttons -->
              <div class="form-row">
                <div class="form-group col-12 d-flex justify-content-between">
                  <button type="button" class="btn btn-secondary" @click="cancelForm">Cancel</button>
                  <button type="submit" class="btn btn-primary">Update Tax</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
  
      <!-- Footer -->
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        form: {
          percentage: '',
          nettotal: false,
          name: '',
        },
        currentDate: '',
        currentTime: '',
        taxId: null,
      };
    },
    mounted() {
      this.taxId = this.$route.params.id;
      this.updateDateTime();
      setInterval(this.updateDateTime, 1000);
      this.fetchTax();
    },
    methods: {
      updateDateTime() {
        const now = new Date();
        this.currentDate = now.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });
        this.currentTime = now.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
      },
      async fetchTax() {
        const token = localStorage.getItem('authToken');
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          const response = await fetch(`${this.$BASE_API_URL}/api/taxes/${this.taxId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          const data = await response.json();
          if (response.ok) {
            this.form.percentage = data.data.percentage;
            this.form.name = data.data.name;
            this.form.nettotal = Boolean(data.data.nettotal); // Ensure boolean
          } else {
            throw new Error(data.message || 'Failed to fetch tax');
          }
        } catch (error) {
          console.error('Error:', error);
          this.$toast.errors(`Error: ${error.message}`);
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      },
      async handleSubmit() {
        const token = localStorage.getItem('authToken');
        const branchId = 1; 
  
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          const response = await fetch(`${this.$BASE_API_URL}/api/taxes/${this.taxId}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              branchId: branchId,
              percentage: parseFloat(this.form.percentage),
              nettotal: this.form.nettotal, // Boolean
              name: this.form.name,
            }),
          });
  
          const data = await response.json();
          if (response.ok) {
            this.$toast.success('Tax updated successfully!');
            this.$router.go(-1);
          } else {
            throw new Error(data.message || 'Failed to update tax');
          }
        } catch (error) {
          console.error('Error:', error);
          this.$toast.error(`Error: ${error.message}`);
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      },
      cancelForm() {
        this.$router.go(-1);
      },
    },
  };
  </script>
  
  <style scoped>
  /* Reuse existing styles from AddTaxComponent */
  .form-control {
    margin-bottom: 15px;
  }
  .btn {
    padding: 8px 20px;
  }
  .btn-primary {
    background-color: #4CAF50;
    border-color: #4CAF50;
  }
  .btn-secondary {
    background-color: #6c757d;
    border-color: #6c757d;
  }
  .form-check-input {
    margin-top: 0.3rem;
  }
  </style>